// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-card-result {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  max-width: 280px;
  background-color: var(--sebrae-light-gray);
  box-shadow: 0px 4px 8px 0px rgba(20, 46, 82, 0.2);
  border-radius: 10px;
}
.wrapper-card-result figure {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.wrapper-card-result figure img {
  width: 100%;
  height: 100%;
  align-self: flex-end;
  object-fit: contain;
}
.wrapper-card-result .wrapper-card__text .type {
  font-family: Figtree;
  font-weight: bold;
  font-size: 11px;
  color: #29C7CC;
  margin-bottom: 8px;
}
.wrapper-card-result .wrapper-card__text .type.Cartilha {
  color: #71CFA7;
}
.wrapper-card-result .wrapper-card__text .type.eBook {
  color: #FF7C48;
}
.wrapper-card-result .wrapper-card__text .title-card {
  font-family: Campuni;
  font-weight: bold;
  font-size: 13px;
  color: var(--sebrae-blue);
  line-height: 1.3;
  margin-bottom: 16px;
  min-height: 51px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wrapper-card-result .wrapper-card__text .title-card.eBook {
  text-align: end;
}
.wrapper-card-result .wrapper-card__text .btn-document-results {
  font-family: Figtree;
  font-weight: 400;
  font-size: 12px;
  background-color: var(--sebrae-blue);
  color: var(--sebrae-white);
  padding: 8px;
  border-radius: 4px;
  max-width: 105px;
  width: 100%;
}
.wrapper-card-result .wrapper-card__text {
  padding: 12px;
}
.wrapper-card-result.content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 12px;
  gap: 24px;
  max-width: 212px;
  height: 269px;
  max-height: 269px;
}
.wrapper-card-result.content figure {
  max-width: 188px;
  width: 100%;
  max-height: 129px;
  height: 100%;
}
.wrapper-card-result.content figure img {
  width: 100%;
  height: 100%;
  align-self: flex-end;
  object-fit: contain;
}
.wrapper-card-result.content .wrapper-card__text {
  padding: 0;
  width: 100%;
}
.wrapper-card-result.content .wrapper-card__text .type {
  font-family: Figtree;
  font-weight: bold;
  font-size: 8px;
  color: var(--sebrae-purple);
  margin-bottom: 8px;
}
.wrapper-card-result.content .wrapper-card__text .title-card {
  font-family: Campuni;
  font-weight: bold;
  font-size: 13px;
  color: var(--sebrae-blue);
  line-height: 1.3;
  margin-bottom: 8px;
  min-height: 34px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wrapper-card-result.content .wrapper-card__text .title-card.eBook {
  text-align: end;
}`, "",{"version":3,"sources":["webpack://./src/components/card-results/index.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,gBAAA;EACA,0CAAA;EACA,iDAAA;EACA,mBAAA;AACJ;AAEI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;AAAR;AAEQ;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;AAAZ;AAKQ;EAEQ,oBAAA;EACA,iBAAA;EACA,eAAA;EAGJ,cAAA;EACA,kBAAA;AANZ;AAQY;EACI,cAAA;AANhB;AASY;EACI,cAAA;AAPhB;AAWQ;EAEQ,oBAAA;EACA,iBAAA;EACA,eAAA;EAGJ,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AAZZ;AAcY;EACI,eAAA;AAZhB;AAgBQ;EAEQ,oBAAA;EACA,gBAAA;EACA,eAAA;EAGJ,oCAAA;EACA,0BAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAjBZ;AAlCI;EAsDI,aAAA;AAjBR;AAoBI;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;AAlBR;AAoBQ;EACI,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AAlBZ;AAqBY;EACI,WAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;AAnBhB;AAuBQ;EACI,UAAA;EACA,WAAA;AArBZ;AAuBY;EAEQ,oBAAA;EACA,iBAAA;EACA,cAAA;EAGJ,2BAAA;EACA,kBAAA;AAxBhB;AA2BY;EAEQ,oBAAA;EACA,iBAAA;EACA,eAAA;EAGJ,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AA5BhB;AA8BgB;EACI,eAAA;AA5BpB","sourcesContent":[".wrapper-card-result {\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    max-width: 280px;\n    background-color: var(--sebrae-light-gray);\n    box-shadow: 0px 4px 8px 0px rgba(20, 46, 82, 0.2);\n    border-radius: 10px;\n\n\n    figure {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: flex-end;\n        align-items: flex-end;\n\n        img {\n            width: 100%;\n            height: 100%;\n            align-self: flex-end;\n            object-fit: contain;\n        }\n    }\n\n    .wrapper-card__text {\n        .type {\n            font: {\n                family: Figtree;\n                weight: bold;\n                size: 11px;\n            }\n\n            color: #29C7CC;\n            margin-bottom: 8px;\n\n            &.Cartilha {\n                color: #71CFA7;\n            }\n\n            &.eBook {\n                color: #FF7C48;\n            }\n        }\n\n        .title-card {\n            font: {\n                family: Campuni;\n                weight: bold;\n                size: 13px;\n            }\n\n            color: var(--sebrae-blue);\n            line-height: 1.3;\n            margin-bottom: 16px;\n            min-height: 51px;\n            overflow: hidden;\n            text-overflow: ellipsis;\n\n            &.eBook {\n                text-align: end;\n            }\n        }\n\n        .btn-document-results {\n            font: {\n                family: Figtree;\n                weight: 400;\n                size: 12px;\n            }\n\n            background-color: var(--sebrae-blue);\n            color: var(--sebrae-white);\n            padding: 8px;\n            border-radius: 4px;\n            max-width: 105px;\n            width: 100%;\n        }\n\n        padding: 12px;\n    }\n\n    &.content {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        align-items: flex-start;\n        padding: 12px;\n        gap: 24px;\n        max-width: 212px;\n        height: 269px;\n        max-height: 269px;\n\n        figure {\n            max-width: 188px;\n            width: 100%;\n            max-height: 129px;\n            height: 100%;\n            \n\n            img {\n                width: 100%;\n                height: 100%;\n                align-self: flex-end;\n                object-fit: contain;\n            }\n        }\n\n        .wrapper-card__text {\n            padding: 0;\n            width: 100%;\n\n            .type {\n                font: {\n                    family: Figtree;\n                    weight: bold;\n                    size: 8px;\n                }\n\n                color: var(--sebrae-purple);\n                margin-bottom: 8px;\n            }\n\n            .title-card {\n                font: {\n                    family: Campuni;\n                    weight: bold;\n                    size: 13px;\n                }\n\n                color: var(--sebrae-blue);\n                line-height: 1.3;\n                margin-bottom: 8px;\n                min-height: 34px;\n                overflow: hidden;\n                text-overflow: ellipsis;\n\n                &.eBook {\n                    text-align: end;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
